import { css } from 'aphrodite';
import { AIAssistantThinkingImageUrl } from '../../../components/ai/AIContentGenerationWizard/models';
import { Modal } from '../../../components/Modal';
import { styleSheet } from './styles';

export function LeoFullscreenThinkingModal({ isOpen, text }: { isOpen: boolean; text: string }) {
	return (
		<Modal isOpen={isOpen} shouldCloseOnOverlayClick={false} className={css(styleSheet.thinkingModal)}>
			<div>
				<img src={AIAssistantThinkingImageUrl} />
			</div>
			<div className={css(styleSheet.thinkingModalMessages)}>
				<p className={css(styleSheet.pill)}>{text}</p>
				<div className={css(styleSheet.thinking)}>
					<span />
					<span />
					<span />
				</div>
			</div>
		</Modal>
	);
}
